export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const SIGN_OUT = '/signout';
export const HOME = '/';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const PORTFOLIO = '/portfolio';
export const BROWSE = '/browse';
export const STOCKS = '/stocks';
export const LEADERBOARD = '/leaderboard';
export const USERS = '/users';
